import styled from 'styled-components';

export const SelectStyle = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  label {
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
    margin-bottom: 5px;
  }

  select {
    box-sizing: border-box;
    padding: 10px;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};

    font-family: 'Ubuntu', sans-serif;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }

  button {
    height: 40px;
    margin-left: 10px;
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }};
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkGreen;
      }};
    }
    &:disabled {
      cursor: not-allowed;
      background-color: ${({ theme }) => {
        return theme.colors.border;
      }};
    }
  }
`;
